export class Upc {
    upc: string;
    productName: string;
    itemSize: string;
    category: string;
    catalogBrand: string;

    constructor(options?: Partial<Upc>) {
        Object.assign(this, options);
    }
}
